import primaryButtonActive from '../../../../../common/algorithms/primary-button-active';

const dark = (params) => primaryButtonActive(params, false);

export default dark;
